import CityGuidesScreen from "../../../screens/Generic/Guides/CityGuidesScreen/CityGuidesScreen"
import { getStaticProps, getStaticPaths } from "../../../screens/Generic/Guides/CityGuidesScreen/data"

export { getStaticProps, getStaticPaths }
export default CityGuidesScreen
